import { Breadcrumb, Col, Row } from "antd";
import InvoicesList from "./InvoicesList";
import { DatePicker } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import AddButton from "../UI/AddButton/addbutton";
import ResetButton from "../UI/ResetButton/resetbutton";
import Title from "../UI/Title/Title";
import { Search } from "../UI/Search/Search";
import { getSalesApi } from "../../api/sales";
import { useMutation } from "react-query";

function Invoices() {
  const { RangePicker } = DatePicker;
  const { t } = useTranslation("common");
  const [search, setSearch] = useState<string>("");
  const [paginatedSales, setPaginatedSales] = useState<any>();
  const [from, setFrom] = useState<string>("");
  const [to, setTo] = useState<string>("");
  const [page, setPage] = useState<number>(1);
  const [tablekey, setTableKey] = useState("");

  const resetFilters = () => {
    getSales({
      limit: page * 10 + 10,
      q: "",
      from: "",
      to: "",
    }).then((res) => {
      setPaginatedSales(res.data?.data);
      setSearch("");
      setTableKey((tableKey) => tableKey + 1);
      setFrom("");
      setTo("");
    });
  };

  const handleSearch = () => {
    getSales({
      limit: page * 10 + 10,
      q: search,
      from: from,
      to: to,
    }).then((res: any) => {
      setPaginatedSales(res.data?.data);
    });
  };

  const getSales = async (params: {
    limit: number;
    q: string;
    from: string;
    to: string;
  }) => {
    // Make your API request here using the updated parameters
    return await SalesMutation(params);
  };

  const { mutateAsync: SalesMutation, isLoading: isSalesLoading } = useMutation(
    "sales",
    getSalesApi
  );

  return (
    <>
      <Row gutter={[10, 10]} style={{ width: "100%" }}>
        <Col offset={1} span={22} style={{ marginBottom: "10px" }}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <>{t("sales")}</>,
              },
              {
                title: (
                  <span className="breadcrumbcolor">
                    {" "}
                    {t("customers-invoices")}
                  </span>
                ),
              },
            ]}
          />
        </Col>

        <Col offset={1} span={22}>
          <Title title={t("customers-invoices")} />{" "}
        </Col>

        <Col offset={1} span={4}>
          <RangePicker
            key={tablekey}
            format={"MM/DD/YYYY"}
            size="large"
            onChange={(dates, datesString) => {
              setFrom(datesString[0]);
              setTo(datesString[1]);
              getSales({
                limit: page * 10 + 10,
                q: search,
                from: datesString[0],
                to: datesString[1],
              }).then((res) => {
                setPaginatedSales(res.data?.data);
              });
            }}
          />
        </Col>

        <Col span={4}>
          <Search
            value={search}
            onKeyPress={(e: any) => e.code === "Enter" && handleSearch()}
            onChange={(e: any) => setSearch(e.target.value)}
          />
        </Col>
        <Col
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
          offset={12}
          span={2}
        >
          <Col>
            <ResetButton
              onClick={() => {
                resetFilters();
              }}
            />
          </Col>
          <AddButton onClick={() => console.log("hh")} />
        </Col>

        <Col offset={1} span={22}>
          <InvoicesList
            from={from}
            to={to}
            paginatedSales={paginatedSales}
            isSalesLoading={isSalesLoading}
            setPaginatedSales={setPaginatedSales}
            SalesMutation={SalesMutation}
            setPage={setPage}
            page={page}
            search={search}
            tablekey={tablekey}
          />
        </Col>
      </Row>
    </>
  );
}

export default Invoices;
